import { computed, makeObservable, observable, runInAction, action } from 'mobx';
import { AgtGoogleProfileStore, AgtGoogleProfileModel, AgtGoogleProfileChangeModel } from '../agt.googleprofile.store';
import { AgenturStore } from '../agentur.store';
import { ISelectOpt } from 'app/components/common/Select';
import { formatBM } from 'app/utils';
import { AgenturModel } from 'app/models/agentur.model';
import _ from 'lodash';
import { BaseUiStore } from './base.ui.store';

export class GoogleProfileBm {
	bm: number;
	bew: number;
	bewAvg: number;
	imgCount: number;
	qCount: number;
	rank: number;
	neueBwertungen: number;
	selbstbau: number;
	constructor(bm: number, bew: number, bewAvg: number, imgCount: number, qCount: number, rank: number, neueBwertungen: number, selbstbau: number) {
		this.bm = bm;
		this.bew = bew;
		this.bewAvg = bewAvg;
		this.imgCount = imgCount;
		this.qCount = qCount;
		this.rank = rank;
		this.neueBwertungen = neueBwertungen;
		this.selbstbau = selbstbau;
	}
}

export class GoogleProfileVM {
	agt: AgenturModel;
	@observable
	item: AgtGoogleProfileModel;

	constructor(agt: AgenturModel, item: AgtGoogleProfileModel) {
		makeObservable(this);
		this.agt = agt;

		this.item = item;
	}

	get gupGpCount() {
		if (this.bew >= 25) {
			return this.agt.thCount ? this.agt.thCount : 1;
		}
		return 0;
	}

	@computed
	get average() {
		return this.item ? this.item.bewertungen : 0;
	}

	@computed
	get bew() {
		return this.item ? this.item.bewertungen : 0;
	}

	@computed
	get bewAvg() {
		return this.item ? this.item.bewertungsdurchschnitt : 0;
	}

	@computed
	get imgCount() {
		return this.item ? this.item.anzahlBilder : 0;
	}

	// @computed
	// get qCount() {
	// 	return this.item ? this.item.anzahlFragen : 0;
	// }

	@computed
	get rank() {
		return this.item ? this.item.ranking : 0;
	}

	@computed
	get neueBewertung() {
		return this.item ? this.item.neueBwertungen : 0;
	}
	@computed
	get selbstbau() {
		return this.item ? this.item.selbstbau : 0;
	}

	changeHistory?: AgtGoogleProfileChangeModel[];

	// @computed
	// get bewValues() {
	// 	const r = this.item
	// 		.map((item, index) => {
	// 			if (index === 0) return item;
	// 			return item.bew > 0 ? item : false;
	// 		})
	// 		.filter(Boolean);
	// 	return r as GoogleProfileBm[];
	// }
}

export class GoogleProfileMultiGp26VM {
	agt: AgenturModel;
	bew: number;
	neueBewGreater3MonthCount: number;
	neueBewGreater3Bms: number[];

	constructor(agt: AgenturModel, bew: number, neueBewGreater3Bms: number[]) {
		this.agt = agt;
		this.bew = bew;
		this.neueBewGreater3Bms = neueBewGreater3Bms;
		this.neueBewGreater3MonthCount = neueBewGreater3Bms.length;
	}

	get agtId() {
		return this.agt.agtId;
	}

	get gpReached() {
		return this.neueBewGreater3MonthCount >= 8;
	}

	get gpCount() {
		return this.gpReached ? (this.agt.thCount || 1) : 0;
	}
}

export class AgtGoogleProfileUiStore extends BaseUiStore<GoogleProfileVM> {
	name = 'AgtGoogleProfileUiStore';
	agtGoogleProfileStore: AgtGoogleProfileStore;
	agenturStore: AgenturStore;

	constructor(agenturStore: AgenturStore, agtGoogleProfileStore: AgtGoogleProfileStore) {
		super();
		makeObservable(this);
		this.agtGoogleProfileStore = agtGoogleProfileStore;
		this.agenturStore = agenturStore;
	}
	@observable
	bms: number[] = [];

	@computed
	get maxBm() {
		if (this.maxBmCurrent) return this.maxBmCurrent;
		return _.max(this.bms);
	}

	@computed
	get minBm() {
		if (this.minBmCurrent) return this.minBmCurrent;
		return _.min(this.bms);
	}

	@computed
	get bmOpts(): ISelectOpt[] {
		return this.bms.map((bm) => {
			return {
				value: bm,
				label: formatBM(bm),
			};
		});
	}

	@observable
	minBmCurrent?: number;

	@observable
	maxBmCurrent?: number;

	// @computed
	// get currentBmItems() {
	// 	const kvVmItems: GoogleProfileVM[] = [];
	// 	this.items.forEach((vm) => {
	// 		const f = vm.item.filter((i) => {
	// 			if (this.minBm && i.bm >= this.minBm) {
	// 				if (this.maxBm && i.bm <= this.maxBm) {
	// 					return true;
	// 				}
	// 			}
	// 			return false;
	// 		});
	// 		const r = new GoogleProfileVM(vm.agt, []);
	// 		runInAction(() => {
	// 			r.item = f;
	// 		});
	// 		kvVmItems.push(r);
	// 	});

	// 	return kvVmItems;
	// }

	// @computed
	// get maxBMItems() {
	// 	const kvVmItems: GoogleProfileVM[] = [];
	// 	const maxBm = this.maxBm;
	// 	this.items.forEach((vm) => {
	// 		const f = vm.item.filter((i) => {
	// 			if (maxBm === i.bm) {
	// 				return true;
	// 			}
	// 			return false;
	// 		});
	// 		const r = new GoogleProfileVM(vm.agt, []);
	// 		runInAction(() => {
	// 			r.item = f;
	// 		});
	// 		kvVmItems.push(r);
	// 	});

	// 	return kvVmItems;
	// }

	async _baseLoad() {
		// Load agencies only - no data loading yet
		const agts = await this.agenturStore.findAll();

		// Get available BMs from the analytics store
		const distinctBms = await this.agtGoogleProfileStore.getDistinctBMs();

		runInAction(() => {
			this.bms = distinctBms;
			// Set default BM range to the most recent month
			if (this.bms.length > 0) {
				this.maxBmCurrent = this.bms[this.bms.length - 1];
				this.minBmCurrent = this.bms[this.bms.length - 1];
			}
		});
	}

	@action
	async loadByBmWithChanges(bm: number) {
		const cacheKey = `loadByBmWithChanges_${bm}`;

		return this.withCache(
			cacheKey,
			async () => {
				const firstBmOfYear = Math.floor(bm / 100) * 100 + 1;
				const p = await Promise.all([
					this.agtGoogleProfileStore.loadTimeSeriesByBm(firstBmOfYear, bm),
					this.loadByBm(bm),
				]);


				let changes = p[0];
				// Group changes by agtId in a single pass
				const changesByAgtId = new Map<number, typeof changes>();
				changes.forEach((change) => {
					if (!changesByAgtId.has(change.agtId)) {
						changesByAgtId.set(change.agtId, []);
					}
					changesByAgtId.get(change.agtId)!.push(change);
				});

				// Assign sorted changes to each item
				this.items.forEach((vm) => {
					const agtChanges = changesByAgtId.get(vm.agt.agtId);
					if (agtChanges && agtChanges.length > 0) {
						// Sort by bm ascending
						agtChanges.sort((a, b) => a.bm - b.bm);
						vm.changeHistory = agtChanges;
					}
				});

				return this.items;
			},
			{
				cacheResult: true,
				measureTime: true,
			}
		);
	}

	@action
	async loadMultiGp26(): Promise<GoogleProfileMultiGp26VM[]> {
		return this.withCache(
			'loadMultiGp26',
			async () => {
				await this.load();
				const bm = this.maxBmCurrent;
				if (!bm) return [];

				const items = await this.loadByBmWithChanges(bm);
				return items.map((item) => {
					const neueBewGreater3Bms = (item.changeHistory || [])
						.filter((ch) => ch.bm >= 202601 && ch.changeNeueBew >= 3)
						.map((ch) => ch.bm);
					return new GoogleProfileMultiGp26VM(item.agt, item.bew, neueBewGreater3Bms);
				});
			},
			{ cacheResult: true },
		);
	}

	@action
	async loadByBm(bm: number) {
		const cacheKey = `AgtGoogleProfileUiStore.loadByBm${bm}`;

		return this.withCache(
			cacheKey,
			async () => {
				console.time('AgtGoogleProfileUiStore.loadByBm');
				await this.load();

				// Load data for the specified BM from analytics store
				const agts = await this.agenturStore.findAll();

				const data = await this.agtGoogleProfileStore.loadByBm(bm)


				const res: GoogleProfileVM[] = [];
				runInAction(() => {
					// Group googleprofile data by agency
					agts.forEach((agt, index) => {
						const agtData = data.find((d) => d.agtId === agt.agtId);
						if (agtData) {
							const vm = new GoogleProfileVM(agt, agtData);
							res.push(vm);
						}
					});

					this.items = res;
				});
				console.timeEnd('AgtGoogleProfileUiStore.loadByBm');

				return res;
			},
			{
				cacheResult: true,
			}
		);
	}

	@action
	async loadGupHistoryLast12Months(agtId: number): Promise<
		{
			bm: string;
			bmRaw: number;
			bewertungen: number;
			neueBewertungen: number;
			bewertungsdurchschnitt: number;
			anzahlBilder: number;
			ranking: number;
		}[]
	> {
		const cacheKey = `AgtGoogleProfileUiStore.loadGupHistoryLast12Months${agtId}`;

		return this.withCache(
			cacheKey,
			async () => {
				// Ensure base data is loaded
				await this.load();

				// Calculate current BM (YYYYMM format)
				const now = new Date();
				const currentBm = now.getFullYear() * 100 + (now.getMonth() + 1);

				// Filter out future months
				const pastBms = this.bms.filter(bm => bm <= currentBm);

				// Get last 12 months of available past data
				const last12Bms = pastBms.slice(-12);

				// Load all data for these months
				const allData = await Promise.all(last12Bms.map((bm) => this.agtGoogleProfileStore.loadByBm(bm)));

				// Extract data for the specific agency and format for chart
				const result = last12Bms.map((bm, index) => {
					const monthData = allData[index];
					const agtData = monthData.find((d) => d.agtId === agtId);

					return {
						bm: formatBM(bm),
						bmRaw: bm,
						bewertungen: agtData?.bewertungen || 0,
						neueBewertungen: agtData?.neueBwertungen || 0,
						bewertungsdurchschnitt: agtData?.bewertungsdurchschnitt || 0,
						anzahlBilder: agtData?.anzahlBilder || 0,
						ranking: agtData?.ranking || 0,
					};
				});

				return result;
			},
			{
				cacheResult: true,
			},
		);
	}

	@action
	async loadGupHistoryLast12MonthsAggregated(agtIds: number[]): Promise<
		{
			bm: string;
			bmRaw: number;
			bewertungen: number;
			neueBewertungen: number;
			bewertungsdurchschnitt: number;
			anzahlBilder: number;
			ranking: number;
		}[]
	> {
		const cacheKey = `AgtGoogleProfileUiStore.loadGupHistoryLast12MonthsAggregated_${agtIds.sort().join('_')}`;

		return this.withCache(
			cacheKey,
			async () => {
				// Ensure base data is loaded
				await this.load();

				// Calculate current BM (YYYYMM format)
				const now = new Date();
				const currentBm = now.getFullYear() * 100 + (now.getMonth() + 1);

				// Filter out future months
				const pastBms = this.bms.filter(bm => bm <= currentBm);

				// Get last 12 months of available past data
				const last12Bms = pastBms.slice(-12);

				// Load all data for these months
				const allData = await Promise.all(last12Bms.map((bm) => this.agtGoogleProfileStore.loadByBm(bm)));

				// Aggregate data across all specified agencies
				const result = last12Bms.map((bm, index) => {
					const monthData = allData[index];

					// Filter to only the specified agencies and aggregate
					let totalBewertungen = 0;
					let totalNeueBewertungen = 0;
					let totalBewertungsdurchschnitt = 0;
					let totalAnzahlBilder = 0;
					let totalRanking = 0;
					let countAgencies = 0;

					agtIds.forEach((agtId) => {
						const agtData = monthData.find((d) => d.agtId === agtId);
						if (agtData) {
							totalBewertungen += agtData.bewertungen || 0;
							totalNeueBewertungen += agtData.neueBwertungen || 0;
							totalBewertungsdurchschnitt += agtData.bewertungsdurchschnitt || 0;
							totalAnzahlBilder += agtData.anzahlBilder || 0;
							totalRanking += agtData.ranking || 0;
							countAgencies++;
						}
					});

					return {
						bm: formatBM(bm),
						bmRaw: bm,
						bewertungen: totalBewertungen,
						neueBewertungen: totalNeueBewertungen,
						bewertungsdurchschnitt: countAgencies > 0 ? totalBewertungsdurchschnitt / countAgencies : 0,
						anzahlBilder: totalAnzahlBilder,
						ranking: countAgencies > 0 ? totalRanking / countAgencies : 0,
					};
				});

				return result;
			},
			{
				cacheResult: true,
			},
		);
	}

	@action
	async loadGupHistoryCountAgtsWithMin3NewReviews(agtIds: number[]): Promise<
		{
			bm: string;
			bmRaw: number;
			countAgtsWithMin3NewReviews: number;
			totalAgencies: number;
			avgBewertungsdurchschnitt: number;
		}[]
	> {
		const cacheKey = `AgtGoogleProfileUiStore.loadGupHistoryCountAgtsWithMin3NewReviews_${agtIds.sort().join('_')}`;

		return this.withCache(
			cacheKey,
			async () => {
				// Ensure base data is loaded
				await this.load();

				// Calculate current BM (YYYYMM format)
				const now = new Date();
				const currentBm = now.getFullYear() * 100 + (now.getMonth() + 1);

				// Filter out future months
				const pastBms = this.bms.filter(bm => bm <= currentBm);

				// Get last 12 months of available past data
				const last12Bms = pastBms.slice(-12);

				// Load all data for these months
				const allData = await Promise.all(last12Bms.map((bm) => this.agtGoogleProfileStore.loadByBm(bm)));

				// Count agencies with >= 3 new reviews per month
				const result = last12Bms.map((bm, index) => {
					const monthData = allData[index];

					let countAgtsWithMin3NewReviews = 0;
					let totalBewertungsdurchschnitt = 0;
					let countAgencies = 0;

					agtIds.forEach((agtId) => {
						const agtData = monthData.find((d) => d.agtId === agtId);
						if (agtData) {
							// Only count neue Bewertungen from 2026 onwards (BM >= 202601)
							if (bm >= 202601 && (agtData.neueBwertungen || 0) >= 3) {
								countAgtsWithMin3NewReviews++;
							}
							totalBewertungsdurchschnitt += agtData.bewertungsdurchschnitt || 0;
							countAgencies++;
						}
					});

					return {
						bm: formatBM(bm),
						bmRaw: bm,
						countAgtsWithMin3NewReviews,
						totalAgencies: countAgencies,
						avgBewertungsdurchschnitt: countAgencies > 0 ? totalBewertungsdurchschnitt / countAgencies : 0,
					};
				});

				return result;
			},
			{
				cacheResult: true,
			},
		);
	}

	@action
	async loadGupHistoryCurrentYearMultiAgency(agtIds: number[]): Promise<
		{
			bm: string;
			bmRaw: number;
			countAgtsWithMin3NewReviews: number;
			totalAgencies: number;
			avgBewertungsdurchschnitt: number;
		}[]
	> {
		const cacheKey = `AgtGoogleProfileUiStore.loadGupHistoryCurrentYearMultiAgency_${agtIds.sort().join('_')}`;

		return this.withCache(
			cacheKey,
			async () => {
				// Ensure base data is loaded
				await this.load();

				// Calculate current BM (YYYYMM format) and start of year
				const now = new Date();
				const currentYear = now.getFullYear();
				const startOfYearBm = currentYear * 100 + 1; // e.g., 202601
				const currentBm = currentYear * 100 + (now.getMonth() + 1);

				// Filter BMs from start of year to current month
				const yearBms = this.bms.filter(bm => bm >= startOfYearBm && bm <= currentBm);

				// Load all data for these months
				const allData = await Promise.all(yearBms.map((bm) => this.agtGoogleProfileStore.loadByBm(bm)));

				// Count agencies with >= 3 new reviews per month
				const result = yearBms.map((bm, index) => {
					const monthData = allData[index];

					let countAgtsWithMin3NewReviews = 0;
					let totalBewertungsdurchschnitt = 0;
					let countAgencies = 0;

					agtIds.forEach((agtId) => {
						const agtData = monthData.find((d) => d.agtId === agtId);
						if (agtData) {
							// Only count neue Bewertungen from 2026 onwards (BM >= 202601)
							if (bm >= 202601 && (agtData.neueBwertungen || 0) >= 3) {
								countAgtsWithMin3NewReviews++;
							}
							totalBewertungsdurchschnitt += agtData.bewertungsdurchschnitt || 0;
							countAgencies++;
						}
					});

					return {
						bm: formatBM(bm),
						bmRaw: bm,
						countAgtsWithMin3NewReviews,
						totalAgencies: countAgencies,
						avgBewertungsdurchschnitt: countAgencies > 0 ? totalBewertungsdurchschnitt / countAgencies : 0,
					};
				});

				return result;
			},
			{
				cacheResult: true,
			},
		);
	}

	@action
	async loadGupHistoryCurrentYearSingleAgency(agtId: number): Promise<
		{
			bm: string;
			bmRaw: number;
			neueBewertungen: number;
		}[]
	> {
		const cacheKey = `AgtGoogleProfileUiStore.loadGupHistoryCurrentYearSingleAgency_${agtId}`;

		return this.withCache(
			cacheKey,
			async () => {
				// Ensure base data is loaded
				await this.load();

				// Calculate current BM (YYYYMM format) and start of year
				const now = new Date();
				const currentYear = now.getFullYear();
				const startOfYearBm = currentYear * 100 + 1; // e.g., 202601
				const currentBm = currentYear * 100 + (now.getMonth() + 1);

				// Filter BMs from start of year to current month
				const yearBms = this.bms.filter(bm => bm >= startOfYearBm && bm <= currentBm);

				// Load all data for these months
				const allData = await Promise.all(yearBms.map((bm) => this.agtGoogleProfileStore.loadByBm(bm)));

				// Extract neue Bewertungen for the specific agency
				const result = yearBms.map((bm, index) => {
					const monthData = allData[index];
					const agtData = monthData.find((d) => d.agtId === agtId);

					return {
						bm: formatBM(bm),
						bmRaw: bm,
						neueBewertungen: agtData?.neueBwertungen || 0,
					};
				});

				return result;
			},
			{
				cacheResult: true,
			},
		);
	}
}
